module.exports = __webpack_public_path__ + "static/media/trashBin.ceef61a5.svg";